module.exports = __webpack_public_path__ + "static/media/spin-win-track-and-trace.b95f34d5.png";